import './_image-zoom-modal.scss';
import component from './image-zoom-modal';

export default component;
